// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前的用户 GET /api/user/me */
export async function getCurrentUser() {
  return request<{ data: API.CurrentUser }>(`/api/user/me/`);
}

export async function initiateWsSession(namespace: string) {
  return request<{ session_id: string; namespace: string }>(`/api/ws-sessions/sessions`, {
    method: 'POST',
    data: { namespace },
  });
}

/** GET tour progress */
export async function getTourProgress() {
  return request<{
    success: boolean;
    data: Record<string, { completed: boolean; currentStep: number }>;
  }>(`/api/user/preferences/tour-progress`);
}

/** PUT tour progress */
export async function saveTourProgress(
  data: Record<string, { completed: boolean; currentStep: number }>,
) {
  return request<{ success: boolean }>(`/api/user/preferences/tour-progress`, {
    method: 'PUT',
    data,
  });
}

/** GET user meta */
export async function getUserMeta() {
  return request<{ data: API.UserMeta }>(`/api/user/meta`);
}

/** 退出登录接口 POST /api/logout/ */
export async function logout() {
  return request(`/api/user/logout/`, { method: 'POST' });
}

/** 登录接口 POST /api/user/login/ */
export async function login(data: API.LoginParams) {
  return request<API.Login>(`/api/user/login/`, { method: 'POST', data });
}

/** GET Microsoft SSO config */
export async function getMicrosoftSSOConfig() {
  return request<API.MicrosoftSSOConfig>(`/api/sso/microsoft/config`);
}

/** POST Microsoft SSO verify */
export async function verifyMicrosoftSSO(data: API.MicrosoftSSOVerify) {
  return request<API.Login>(`/api/sso/microsoft/verify`, { method: 'POST', data });
}

/** POST register current organisation Microsoft tenant */
export async function registerCurrentOrganisationMicrosoftTenant(data: API.MicrosoftSSOVerify) {
  return request<{
    success: boolean;
    message: string;
    data: {
      tenant_id: string;
      added: boolean;
      ms_tenant_ids: string[];
    };
  }>(`/api/organisation/current/ms-tenant/register`, {
    method: 'POST',
    data,
  });
}

/** GET sample files for chat tour */
export async function getChatSamples() {
  return request<{ success: boolean; data: string[] }>(`/api/samples/chat`);
}

/** GET sample files for review tour */
export async function getReviewSamples() {
  return request<{ success: boolean; data: string[] }>(`/api/samples/review`);
}

/** GET sample files for playbook tour */
export async function getPlaybookSamples() {
  return request<{ success: boolean; data: string[] }>(`/api/samples/playbook`);
}

/** GET list of portal users*/
export async function portalUsers(params: API.PortalUserListParams) {
  return request<{ data: API.PortalUserList[] }>(`/api/users/`, {
    method: 'GET',
    params,
  });
}

/** POST portal user */
export async function addPortalUser(data: API.PortalUserNew) {
  return request<API.ResponseResult>(`/api/users/`, { method: 'POST', data });
}

/** PATCH portal user */
export async function updatePortalUser(data: API.PortalUserUpdate) {
  return request<API.ResponseResult>(`/api/users/${data.id}`, {
    method: 'PATCH',
    data,
  });
}

/** DELETE portal user */
export async function removePortalUser(id: string) {
  return request<API.ResponseResult>(`/api/users/${id}`, { method: 'DELETE' });
}

/** Revert Delete portal user */
export async function undoRemovePortalUser(id: string) {
  return request<API.ResponseResult>(`/api/users/${id}/undo/`, {
    method: 'DELETE',
  });
}

/** Dormant portal user */
export async function dormantPortalUser(id: string) {
  return request<API.ResponseResult>(`/api/users/dormant/${id}`, {
    method: 'PATCH',
  });
}

/** Reactivate portal user */
export async function reactivatePortalUser(id: string) {
  return request<API.ResponseResult>(`/api/users/reactivate/${id}`, {
    method: 'PATCH',
  });
}

/** Reset portal user password */
export async function resetPasswordPortalUser(data: API.PortalUserPasswordReset) {
  return request<API.ResponseResult>(`/api/user/reset-password/`, {
    method: 'POST',
    data,
  });
}

/** Reset other person portal user password */
export async function resetOtherPasswordPortalUser(
  data: API.PortalUserPasswordReset | null,
  userId: string,
) {
  return request<API.ResponseResult>(`/api/user/reset-password/${userId}`, {
    method: 'POST',
    ...(data ? { data } : {}),
  });
}

/** Unlock portal user */
export async function unlockPortalUser(id: string) {
  return request<API.ResponseResult>(`/api/users/unlock/${id}`, {
    method: 'PATCH',
  });
}

/** GET bot user */
export async function botUsers(params: API.BotUserParams) {
  return request<{ data: API.BotUserList[]; total: number }>(`/api/conversations/`, { params });
}

/** GET bot user messages */
export async function botUserMessages(id: string, params: API.BotUserMessageParams) {
  return request<{ data: API.BotUserMessageList[]; total: number }>(`/api/conversations/${id}`, {
    params,
  });
}

/** GET bot user meta */
export async function botUserMeta(id: string) {
  return request<{ data: API.BotUserMeta }>(`/api/botuser/${id}`);
}

/** GET bot user tags */
export async function botUserTags() {
  return request<{ data: string[] }>(`/api/botuser/tags/`);
}

/** PATCH bot user */
export async function updateBotUser(id: string, data: API.BotUserUpdate) {
  return request<API.ResponseResult>(`/api/botuser/${id}`, {
    method: 'patch',
    data,
  });
}

/** GET CTA flows */
export async function ctaFlows() {
  return request(`/api/broadcasts/cta/`);
}

/** GET flows */
export async function flows(params: API.FlowListParams) {
  return request<{ data: API.FlowList[] }>(`/api/flows/`, { params });
}

/** GET flow */
export async function flow(id: string) {
  return request<{ data: API.FlowItem }>(`/api/flows/${id}`);
}

/** GET new flow */
export async function newFlow() {
  return request<{ data: API.NewFlowItem }>(`/api/flows/new/`);
}

/** POST COPY flow */
export async function duplicateFlow(id: string) {
  return request(`/api/flows/duplicate/${id}`, { method: 'POST' });
}

/** POST CLEAN flow */
export async function cleanFlow(data: API.FlowGroupItem[]) {
  return request(`/api/flows/clean/`, { method: 'POST', data });
}

/** POST flow */
export async function addFlow(data: API.FlowItem) {
  return request(`/api/flows/`, { method: 'POST', data });
}

/** PUT flow */
export async function updateFlow(data: API.FlowItem) {
  return request(`/api/flows/`, { method: 'PUT', data });
}

export const upload = `/api/upload/`;

/** GET entity flow id */
export async function entityFlow() {
  return request(`/api/flows/entity/`);
}

/** DELETE flow*/
export async function removeFlows(data: { key: string[] }) {
  return request(`/api/flows/`, { method: 'DELETE', data });
}

/** UNDO DELETE flow */
export async function undoRemoveFlows(data: { key: string[] }) {
  return request(`/api/flows/undo/`, { method: 'DELETE', data });
}

/** GET question */
export async function question(id: string) {
  return request(`/api/questions/${id}`);
}

/** GET LLM metrics */
export async function getLLMMetrics() {
  return request<{ data: any }>(`/api/bot/llm-metrics`);
}

/** Switch active organisation */
export async function switchOrganisation(orgId: string) {
  return request<API.Login>(`/api/user/switch-organisation/${orgId}`, {
    method: 'POST',
  });
}

/** GET list of organisations for current user */
export async function getOrganisations() {
  return request<{ data: API.CurrentUser['organisations'] }>(`/api/organisation`);
}

/** GET organisation details */
export async function getOrganisationDetails(id: string) {
  return request<{ data: any }>(`/api/organisation/${id}/details`);
}

/** GET organisation users */
export async function getOrganisationUsers(id: string) {
  return request<{ data: any[] }>(`/api/organisation/${id}/users`);
}

/** GET organisation roles */
export async function getOrganisationRoles() {
  return request<{ data: any[] }>(`/api/organisation/roles`);
}

/** POST add user to organisation */
export async function addOrganisationUser(
  organisationId: string,
  data: {
    email: string;
    role_id: string;
    username?: string;
    first_name?: string;
    last_name?: string;
  },
) {
  return request<{ data: any }>(`/api/organisation/${organisationId}/users`, {
    method: 'POST',
    data,
  });
}

/** PUT update user role in organisation */
export async function updateOrganisationUserRole(
  organisationId: string,
  userId: string,
  data: { role_id: string },
) {
  return request<{ data: any }>(`/api/organisation/${organisationId}/users/${userId}`, {
    method: 'PUT',
    data,
  });
}

/** DELETE remove user from organisation */
export async function removeOrganisationUser(organisationId: string, userId: string) {
  return request<{ data: any }>(`/api/organisation/${organisationId}/users/${userId}`, {
    method: 'DELETE',
  });
}

/** POST create organisation */
export async function createOrganisation(data: { name: string }) {
  return request<{ data: any }>(`/api/organisation`, {
    method: 'POST',
    data,
  });
}

/** PUT update organisation */
export async function updateOrganisation(id: string, data: any) {
  return request<{ data: any }>(`/api/organisation/${id}`, {
    method: 'PUT',
    data,
  });
}

/** GET billing plans for current organisation */
export async function getBillingPlans() {
  return request<{ data: API.BillingPlan[] }>(`/api/billing/plans`, {
    method: 'GET',
  });
}

/** GET billing status for current organisation */
export async function getBillingStatus() {
  return request<{ data: API.BillingStatus }>(`/api/billing/status`, {
    method: 'GET',
  });
}

/** GET billing invoices and next invoice for current organisation */
export async function getBillingInvoices() {
  return request<{ data: API.BillingInvoicesResponse }>(`/api/billing/invoices`, {
    method: 'GET',
  });
}

/** GET billing invoice PDF (blob) */
export async function downloadBillingInvoicePdf(invoiceId: string): Promise<Blob> {
  const token = localStorage.getItem('token');
  const resp = await fetch(`/api/billing/invoices/${invoiceId}/pdf`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!resp.ok) throw new Error(`Invoice PDF download failed: ${resp.status}`);
  return resp.blob();
}

/** POST create billing checkout session */
export async function createBillingCheckoutSession(
  planCode: string,
  seats: number,
  successUrl?: string,
  cancelUrl?: string,
  customerEmail?: string,
  customerName?: string,
) {
  const data: API.BillingCheckoutSessionRequest = { planCode, seats };
  if (successUrl) data.successUrl = successUrl;
  if (cancelUrl) data.cancelUrl = cancelUrl;
  if (customerEmail) data.customerEmail = customerEmail;
  if (customerName) data.customerName = customerName;

  return request<{ data: API.BillingCheckoutSessionResponse }>(`/api/billing/checkout-session`, {
    method: 'POST',
    data,
  });
}

/** POST create Stripe billing portal session */
export async function createBillingPortalSession(returnUrl?: string) {
  const data: API.BillingPortalSessionRequest | undefined = returnUrl ? { returnUrl } : undefined;

  return request<{ data: API.BillingPortalSessionResponse }>(`/api/billing/portal-session`, {
    method: 'POST',
    data,
  });
}

/** PATCH update seat quantity for current organisation */
export async function updateBillingSeats(seats: number) {
  return request<{ data: API.BillingStatus }>(`/api/billing/seats`, {
    method: 'PATCH',
    data: { seats },
  });
}

/** GET super-admin billing controls for an organisation */
export async function getOrgBillingControls(organisationId: string) {
  return request<{ data: API.BillingOrgControls }>(
    `/api/billing/admin/organisation/${organisationId}/status`,
    {
      method: 'GET',
    },
  );
}

/** PATCH super-admin hidden plan allowlist for an organisation */
export async function updateOrgBillingHiddenPlanAllowlist(
  organisationId: string,
  data: API.BillingHiddenPlanAllowlistRequest,
) {
  const payload = {
    allowHiddenPlans: data.hiddenPlanAllowlisted,
    reason: data.reason,
  };
  return request<{ data: API.BillingOrgControls }>(
    `/api/billing/admin/organisation/${organisationId}/allow-hidden-plans`,
    {
      method: 'PATCH',
      data: payload,
    },
  );
}

/** PATCH super-admin exemption/manual mode for an organisation */
export async function updateOrgBillingExemptManualMode(
  organisationId: string,
  data: API.BillingExemptManualModeRequest,
) {
  const payload = {
    billingManualMode: data.isExemptManualMode,
    billingExempt: data.isExemptManualMode,
    reason: data.reason,
  };
  return request<{ data: API.BillingOrgControls }>(
    `/api/billing/admin/organisation/${organisationId}/manual-mode`,
    {
      method: 'PATCH',
      data: payload,
    },
  );
}
